module.exports = __webpack_public_path__ + "static/artist-marketing-hero-mobile-7da751d3b249f5f157857189dd645f4c.png";